module.exports = __webpack_public_path__ + "img/header-diamondJewelryBestseller.b883788.webp";